/* Kalve product cards: the black add-to-cart bar, its in-place size row, the finish swatches and the phone behaviour of the bar.
   - swatch click: only toggles classes / text (photo layer, price, ?variant= links, bar state); everything was precomputed by Liquid
   - bar press: mode "add" adds the selected finish at once; mode "size" turns the bar into a row of size chips (tap = add);
     mode "page" opens the product page
   - phones / touch: the bar slides up 1s after the last scroll (cards >= 60% in view) and drops when scrolling resumes
   Strings come from the JSON blob printed inside each bar. Safe to include more than once. No third-party requests. */
(function () {
  'use strict';
  if (window.KalveQuickAdd) return;

  var doc = document;
  var strings = null;
  var active = null;      // { bar, card, scrollY } while a size row is open

  /* the photo slide (packshot -> model photo) follows a real mouse only: html.k-mouse is set by mouse movement and cleared by a touch,
     so phones and tablets that report (hover: hover) or open the desktop site never slide (kalve-quickadd.css) */
  doc.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') doc.documentElement.classList.add('k-mouse'); }, { passive: true });
  doc.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') doc.documentElement.classList.remove('k-mouse'); }, { passive: true });

  /* ---------- helpers ---------- */
  function str(key, fallback) {
    if (!strings) {
      var node = doc.querySelector('script[data-k-qa-strings]');
      try { strings = node ? JSON.parse(node.textContent) : {}; } catch (e) { strings = {}; }
    }
    return strings[key] || fallback || '';
  }

  function el(tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (text != null && text !== '') n.textContent = text;
    return n;
  }

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function announce(text) {
    var live = doc.querySelector('[data-k-qa-live]');
    if (!live) {
      live = el('div', 'k-sr');
      live.setAttribute('data-k-qa-live', '');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.style.display = 'block';
      doc.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text || ''; }, 30);
  }

  function parseSizes(s) {
    if (!s) return [];
    var list = s.split(';').filter(Boolean).map(function (part) {
      var f = part.split(':');
      return { label: f[0], id: f[1], ok: f[2] === '1' };
    });
    if (list.every(function (x) { return /^[0-9]+([.,][0-9]+)?$/.test(x.label); })) list.sort(function (a, b) { return parseFloat(a.label.replace(',', '.')) - parseFloat(b.label.replace(',', '.')); });
    return list;
  }

  function cardState(card) {
    var bar = card.querySelector('.k-qa-bar');
    var sw = card.querySelector('[data-k-sw-value][aria-checked="true"]');
    return {
      bar: bar,
      main: bar && bar.querySelector('.k-qa-bar__main'),
      mode: bar && bar.getAttribute('data-k-mode'),
      variant: sw ? sw.getAttribute('data-k-sw-variant') : (bar && bar.getAttribute('data-k-variant')),
      sizes: parseSizes(sw ? sw.getAttribute('data-k-sw-sizes') : (bar && bar.getAttribute('data-k-sizes'))),
      sold: sw ? sw.getAttribute('data-k-sw-sold') === '1' : false
    };
  }

  /* ---------- adding ---------- */
  function addDirect(id) {
    if (window.KalveCart && typeof window.KalveCart.add === 'function') return window.KalveCart.add([{ id: Number(id), quantity: 1 }]);
    window.location.href = rootUrl() + 'cart/add?id=' + encodeURIComponent(id) + '&quantity=1';
    return new Promise(function () {});
  }

  function setLabel(bar, text) {
    var l = bar.querySelector('.k-qa-bar__label');
    if (l) l.textContent = text;
  }

  /* add one variant; flash = show "ADDED" on the bar afterwards (direct add), else the bar simply returns to its normal label */
  function add(bar, id, flash) {
    if (bar.classList.contains('is-busy')) return;
    var idle = str('add', 'Add to cart');
    bar.classList.add('is-busy');
    function done(label, delay) {
      setLabel(bar, label);
      setTimeout(function () { bar.classList.remove('is-busy'); setLabel(bar, idle); }, delay);
    }
    addDirect(id).then(function () {
      announce(str('added'));
      if (flash) done(str('addedShort', 'Added'), 1000); else done(idle, 0);
    }).catch(function (err) {
      var msg = (err && err.message) || str('error');
      announce(msg);
      done(msg, 3000);
    });
  }

  /* ---------- size row ---------- */
  function buildChips(card) {
    var st = cardState(card);
    var box = st.bar.querySelector('[data-k-chips]');
    if (!box) return;
    box.textContent = '';
    var soldTpl = str('optionSoldOut', '__KVAL__ (sold out)');
    st.sizes.forEach(function (sz) {
      var b = el('button', 'k-qa-chip', sz.label);
      b.type = 'button';
      b.setAttribute('data-k-size', sz.id);
      if (!sz.ok) { b.disabled = true; b.setAttribute('aria-label', soldTpl.replace('__KVAL__', sz.label)); }
      box.appendChild(b);
    });
  }

  function openSizes(card) {
    var st = cardState(card);
    if (!st.bar || st.sold) return;
    collapse(false);
    buildChips(card);
    st.bar.classList.add('is-sizing');
    active = { bar: st.bar, card: card, scrollY: window.pageYOffset };
    var first = st.bar.querySelector('button.k-qa-chip:not(:disabled)') || st.bar.querySelector('.k-qa-bar__x');
    if (first) first.focus({ preventScroll: true });
  }

  function collapse(restoreFocus) {
    if (!active) return;
    var a = active;
    active = null;
    a.bar.classList.remove('is-sizing');
    if (restoreFocus) {
      var main = a.bar.querySelector('.k-qa-bar__main');
      if (main) main.focus({ preventScroll: true });
    }
  }

  /* ---------- phones: the "+" opens ONE sheet fixed to the bottom of the screen (sizes as plain text + black ADD TO CART bar) ---------- */
  var mOpen = null;       // the card whose "+" opened the sheet
  var sheet = null, sheetSizes = null, sheetAdd = null, sheetBusy = false;

  function sheetEl() {
    if (sheet) return sheet;
    sheet = el('div', 'k-sheet');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-label', str('add', 'Add to cart'));
    sheetSizes = el('div', 'k-sheet__sizes');
    sheetSizes.setAttribute('role', 'group');
    sheetAdd = el('button', 'k-sheet__add');
    sheetAdd.type = 'button';
    sheetAdd.setAttribute('data-k-sheet-add', '');
    sheet.appendChild(sheetSizes);
    sheet.appendChild(sheetAdd);
    doc.body.appendChild(sheet);
    return sheet;
  }

  function sheetChosen() { var c = sheetSizes && sheetSizes.querySelector('button.k-sheet__sz.is-chosen'); return c || null; }

  /* ADD TO CART is greyed until a size is chosen (sized products) and for a sold-out finish */
  function sheetState() {
    if (!mOpen) return;
    var st = cardState(mOpen);
    var need = st.mode === 'size' && !sheetChosen();
    sheetAdd.disabled = st.sold || need || sheetBusy;
    if (!sheetBusy) sheetAdd.textContent = st.sold ? str('soldOut', 'Sold out') : str('add', 'Add to cart');
  }

  function sheetRender() {
    if (!mOpen) return;
    sheetEl();
    var st = cardState(mOpen);
    var prev = sheetChosen();
    var keep = prev ? prev.textContent : '';
    sheetSizes.textContent = '';
    if (st.mode === 'size') {
      sheetSizes.hidden = false;
      sheetSizes.style.setProperty('--k-cols', String(Math.min(Math.max(st.sizes.length, 1), 7)));
      var soldTpl = str('optionSoldOut', '__KVAL__ (sold out)');
      st.sizes.forEach(function (sz) {
        var b = el('button', 'k-sheet__sz', sz.label);
        b.type = 'button';
        b.setAttribute('data-k-size', sz.id);
        if (!sz.ok) { b.disabled = true; b.setAttribute('aria-label', soldTpl.replace('__KVAL__', sz.label)); }
        else if (keep && sz.label === keep) b.classList.add('is-chosen');
        sheetSizes.appendChild(b);
      });
    } else {
      sheetSizes.hidden = true;
    }
    sheetState();
  }

  function mClose() {
    if (!mOpen) return;
    var pl = mOpen.querySelector('[data-k-plus]');
    if (pl) pl.setAttribute('aria-expanded', 'false');
    mOpen = null;
    if (sheet) sheet.classList.remove('is-open');
  }

  function mOpenCard(card) {
    mClose();
    mOpen = card;
    sheetBusy = false;
    sheetEl();
    sheetSizes.textContent = '';
    sheetRender();
    var pl = card.querySelector('[data-k-plus]');
    if (pl) pl.setAttribute('aria-expanded', 'true');
    void sheet.offsetWidth; // let the sheet start below the screen so it slides up
    sheet.classList.add('is-open');
  }

  function sheetSubmit() {
    if (!mOpen || sheetBusy) return;
    var card = mOpen;
    var st = cardState(card);
    if (st.sold) return;
    if (st.mode === 'page') {
      var link = card.querySelector('a[href*="/products/"]');
      window.location.href = (link && link.getAttribute('href')) || (rootUrl() + 'products/' + (st.bar.querySelector('[data-k-quick-add]').getAttribute('data-k-quick-add')));
      return;
    }
    var vid = st.variant;
    if (st.mode === 'size') { var c = sheetChosen(); vid = c ? c.getAttribute('data-k-size') : ''; }
    if (!vid) return; // never add a sized product without a size
    sheetBusy = true;
    sheetAdd.disabled = true;
    sheetAdd.textContent = str('adding', 'Adding');
    addDirect(vid).then(function () {
      announce(str('added'));
      sheetBusy = false;
      if (mOpen === card) mClose();
    }).catch(function (err) {
      var msg = (err && err.message) || str('error');
      announce(msg);
      sheetAdd.textContent = msg;
      setTimeout(function () { sheetBusy = false; sheetState(); }, 2500);
    });
  }

  /* ---------- bar press ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var chip = t.closest('button.k-qa-chip');
    if (chip) {
      var bar = chip.closest('.k-qa-bar');
      e.preventDefault();
      if (chip.disabled || !bar) return;
      var id = chip.getAttribute('data-k-size');
      collapse(false);
      add(bar, id, false);
      return;
    }

    if (t.closest('[data-k-bar-close]')) { e.preventDefault(); collapse(true); return; }

    var szBtn = t.closest('button.k-sheet__sz');
    if (szBtn) {
      e.preventDefault();
      if (szBtn.disabled) return;
      Array.prototype.forEach.call(sheetSizes.querySelectorAll('button.k-sheet__sz'), function (c) { c.classList.toggle('is-chosen', c === szBtn); });
      sheetState();
      return;
    }
    if (t.closest('[data-k-sheet-add]')) { e.preventDefault(); sheetSubmit(); return; }

    var plus = t.closest('[data-k-plus]');
    if (plus) {
      e.preventDefault();
      var pcard = plus.closest('[data-k-card]');
      if (!pcard) return;
      if (mOpen === pcard) mClose(); else mOpenCard(pcard);
      return;
    }

    var main = t.closest('[data-k-quick-add]');
    if (main) {
      e.preventDefault();
      var card = main.closest('[data-k-card]');
      if (!card) return;
      var st = cardState(card);
      if (st.sold || st.bar.classList.contains('is-busy')) return;
      if (st.mode === 'size') { openSizes(card); return; }
      if (st.mode === 'add' && st.variant) { add(st.bar, st.variant, true); return; }
      var link = card.querySelector('a[href*="/products/"]');
      window.location.href = (link && link.getAttribute('href')) || main.getAttribute('data-k-url') || (rootUrl() + 'products/' + main.getAttribute('data-k-quick-add'));
    }
  });

  /* collapse: Escape, a press outside the bar, the mouse leaving the card, scrolling more than 40px */
  doc.addEventListener('keydown', function (e) {
    if (active && e.key === 'Escape') { e.preventDefault(); collapse(true); }
  });
  doc.addEventListener('pointerdown', function (e) {
    if (mOpen) {
      var mt = e.target;
      if (!(mt instanceof Element) || !(mt.closest('.k-sheet') || (mOpen.contains(mt) && mt.closest('[data-k-plus], [data-k-sw]')))) mClose();
    }
    if (!active) return;
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (active.bar.contains(t)) return;
    if (t.closest('[data-k-sw]') && active.card.contains(t)) return; // picking another finish keeps the row open (it is rebuilt)
    collapse(false);
  });
  /* a swatch pick keeps the static shot until the pointer (or keyboard focus) leaves the card; on phones the scroll cycle clears it (see slideDown) */
  doc.addEventListener('mouseout', function (e) {
    var from = e.target instanceof Element ? e.target.closest('[data-k-card].is-picked') : null;
    if (from && !isPhone() && !(e.relatedTarget instanceof Node && from.contains(e.relatedTarget))) from.classList.remove('is-picked');
  });
  doc.addEventListener('focusout', function (e) {
    var from = e.target instanceof Element ? e.target.closest('[data-k-card].is-picked') : null;
    if (from && !(e.relatedTarget instanceof Node && from.contains(e.relatedTarget))) from.classList.remove('is-picked');
  });
  doc.addEventListener('mouseout', function (e) {
    if (!active || !window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    var to = e.relatedTarget;
    if (e.target instanceof Element && active.card.contains(e.target) && !(to instanceof Node && active.card.contains(to))) collapse(false);
  });
  window.addEventListener('scroll', function () {
    if (active && Math.abs(window.pageYOffset - active.scrollY) > 40) collapse(false);
  }, { passive: true });

  /* ---------- finish swatches: class / text toggles only ---------- */
  function setCardPrice(card, btn) {
    var price = card.querySelector('[data-k-price]');
    if (!price) return;
    price.textContent = '';
    var pre = btn.getAttribute('data-k-sw-pre');
    var post = btn.getAttribute('data-k-sw-post');
    if (pre) price.appendChild(el('span', 'k-from', pre));
    price.appendChild(el('b', 'k-amt', btn.getAttribute('data-k-sw-amt')));
    if (post) price.appendChild(el('span', 'k-from', post));
  }

  function selectSwatch(btn) {
    var group = btn.closest('[data-k-sw]');
    var card = btn.closest('[data-k-card]');
    if (!group || !card) return;
    var all = group.querySelectorAll('[data-k-sw-value]');
    for (var i = 0; i < all.length; i++) {
      var on = all[i] === btn;
      all[i].setAttribute('aria-checked', on ? 'true' : 'false');
      all[i].tabIndex = on ? 0 : -1;
    }
    setCardPrice(card, btn);
    var matEl = card.querySelector('.k-ce__mat');
    var matTxt = btn.getAttribute('data-k-sw-mat');
    if (matEl && matTxt) matEl.textContent = matTxt;
    card.classList.add('is-picked'); // the picked finish's static shot stays visible: the model photo is suppressed until the pointer leaves / the next scroll cycle

    var layer = btn.getAttribute('data-k-sw-layer');
    var layers = card.querySelectorAll('.k-ly');
    if (layer !== '' && layers.length) {
      for (var j = 0; j < layers.length; j++) {
        var show = layers[j].getAttribute('data-k-layer') === layer;
        layers[j].classList.toggle('is-on', show);
        if (show) layers[j].removeAttribute('aria-hidden'); else layers[j].setAttribute('aria-hidden', 'true');
      }
    }

    var id = btn.getAttribute('data-k-sw-variant');
    if (id) {
      var links = card.querySelectorAll('a[href*="/products/"]');
      for (var k = 0; k < links.length; k++) links[k].setAttribute('href', links[k].getAttribute('href').split('?')[0] + '?variant=' + id);
    }

    var st = cardState(card);
    if (st.bar) {
      var sold = btn.getAttribute('data-k-sw-sold') === '1';
      st.bar.classList.toggle('is-soldout', sold);
      if (st.main) st.main.disabled = sold;
      if (!st.bar.classList.contains('is-busy')) setLabel(st.bar, sold ? str('soldOut', 'Sold out') : str('add', 'Add to cart'));
      if (sold && active && active.bar === st.bar) collapse(false);
      else if (active && active.bar === st.bar) buildChips(card);
      if (mOpen === card) sheetRender();
    }
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var sw = t.closest('[data-k-sw] [data-k-sw-value]');
    if (!sw) return;
    e.preventDefault();
    selectSwatch(sw);
  });

  doc.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.matches('[data-k-sw] [data-k-sw-value]')) return;
    var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0);
    if (!dir) return;
    var all = Array.prototype.slice.call(t.closest('[data-k-sw]').querySelectorAll('[data-k-sw-value]'));
    var next = all[(all.indexOf(t) + dir + all.length) % all.length];
    e.preventDefault();
    selectSwatch(next);
    next.focus();
  });

  /* ---------- hidden photo layers: fetch them while the card is near the viewport (never at click time) ---------- */
  var nearIo = null;
  var nearSeen = typeof WeakSet === 'function' ? new WeakSet() : null;

  function fetchLayers(card) {
    Array.prototype.forEach.call(card.querySelectorAll('img.k-ly[loading="lazy"]'), function (img) { img.loading = 'eager'; });
  }

  function watchNear() {
    var vh = window.innerHeight || 800;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-k-card]'), function (c) {
      if (!c.querySelector('img.k-ly[loading="lazy"]')) return;
      var r = c.getBoundingClientRect();
      if (r.top < vh + 600 && r.bottom > -600) { fetchLayers(c); return; } // already near: no need to wait for the observer
      if (!nearIo || !nearSeen || nearSeen.has(c)) return;
      nearSeen.add(c);
      nearIo.observe(c);
    });
  }

  if ('IntersectionObserver' in window) {
    nearIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        nearIo.unobserve(en.target);
        fetchLayers(en.target);
      });
    }, { rootMargin: '600px 0px' });
  }

  /* ---------- phones / touch: the bar is hidden while scrolling and slides up 1s after the last scroll ---------- */
  var IDLE_MS = 1000;
  var phoneMq = window.matchMedia ? window.matchMedia('not all and (min-width: 901px) and (hover: hover)') : null;
  var io = null;
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var inView = [];
  var idle = false;
  var idleTimer = 0;

  function isPhone() { return !!(phoneMq && phoneMq.matches); }
  function mark() { /* phones: the bar no longer slides up by itself; the "+" opens it */ }

  function scan() {
    watchNear();
    if (!io || !seen) return;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-k-card]'), function (c) {
      if (!seen.has(c)) { seen.add(c); io.observe(c); }
    });
  }

  function slideUp() {
    idle = true;
    if (!isPhone()) return;
    scan();
    inView = inView.filter(function (c) { return c.isConnected; });
    inView.forEach(function (c) { mark(c, true); });
  }

  function slideDown() {
    idle = false;
    Array.prototype.forEach.call(doc.querySelectorAll('.k-qa-bar.is-up'), function (b) { b.classList.remove('is-up'); });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-k-card].is-picked'), function (c) { c.classList.remove('is-picked'); });
  }

  function onMove() {
    if (!isPhone()) return;
    if (idle) slideDown();
    clearTimeout(idleTimer);
    idleTimer = setTimeout(slideUp, IDLE_MS);
  }

  if ('IntersectionObserver' in window && phoneMq) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var on = en.isIntersecting && en.intersectionRatio >= 0.6;
        var i = inView.indexOf(en.target);
        if (on && i < 0) inView.push(en.target);
        if (!on && i > -1) inView.splice(i, 1);
        if (!en.isIntersecting) en.target.classList.remove('is-picked');
        if (idle && isPhone()) mark(en.target, on);
      });
    }, { threshold: [0.6] });
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    var onMq = function () { if (!isPhone()) { clearTimeout(idleTimer); slideDown(); } else { onMove(); } };
    if (phoneMq.addEventListener) phoneMq.addEventListener('change', onMq); else if (phoneMq.addListener) phoneMq.addListener(onMq);
    idleTimer = setTimeout(slideUp, IDLE_MS); // nobody has scrolled yet: the first idle second counts too
  }
  doc.addEventListener('shopify:section:load', scan);
  scan();

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    collapse(false);
    mClose();
    Array.prototype.forEach.call(doc.querySelectorAll('.k-qa-bar.is-busy'), function (b) { b.classList.remove('is-busy'); setLabel(b, str('add', 'Add to cart')); });
  });

  window.KalveQuickAdd = { close: function () { collapse(true); } };
})();
